var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2.99731 5.75C2.99731 4.23579 4.2331 3 5.74731 3H11.1973C12.7115 3 13.9473 4.23579 13.9473 5.75V7C13.9473 7.41421 13.6115 7.75 13.1973 7.75C12.7831 7.75 12.4473 7.41421 12.4473 7V5.75C12.4473 5.06421 11.8831 4.5 11.1973 4.5H5.74731C5.06153 4.5 4.49731 5.06421 4.49731 5.75V18.25C4.49731 18.9358 5.06153 19.5 5.74731 19.5H11.1973C11.8831 19.5 12.4473 18.9358 12.4473 18.25V17C12.4473 16.5858 12.7831 16.25 13.1973 16.25C13.6115 16.25 13.9473 16.5858 13.9473 17V18.25C13.9473 19.7642 12.7115 21 11.1973 21H5.74731C4.2331 21 2.99731 19.7642 2.99731 18.25V5.75ZM16.4778 8.21885C16.7711 7.92641 17.246 7.92714 17.5385 8.22049L20.7785 11.4705C21.0703 11.7632 21.0703 12.2368 20.7785 12.5295L17.5385 15.7795C17.246 16.0729 16.7711 16.0736 16.4778 15.7811C16.1845 15.4887 16.1837 15.0138 16.4762 14.7205L18.4406 12.75H9.98731C9.5731 12.75 9.23731 12.4142 9.23731 12C9.23731 11.5858 9.5731 11.25 9.98731 11.25H18.4406L16.4762 9.27951C16.1837 8.98617 16.1845 8.51129 16.4778 8.21885Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeave);
export default __webpack_public_path__ + "static/media/leave.30f8566f.svg";
export { ForwardRef as ReactComponent };